import { cacheableTypes } from './cacheableTypes.tsx';

const calculateTransferType = (type: string, duration: number, size: number | undefined) => {
	if (!cacheableTypes.includes(type)) {
		return null;
	}

	if ((size === undefined || size === 0) && duration === 0) {
		return CacheHitRatioSummary.MEMORY_KEY;
	}
	if (size === 0 && duration > 0) {
		return CacheHitRatioSummary.DISK_KEY;
	}
	if (size === undefined) {
		return null;
	}

	return CacheHitRatioSummary.NETWORK_KEY;
};

export class CacheHitRatioSummary {
	static MEMORY_KEY = 'mem';

	static DISK_KEY = 'disk';

	static NETWORK_KEY = 'net';

	bundles: {
		[CacheHitRatioSummary.MEMORY_KEY]: number;
		[CacheHitRatioSummary.DISK_KEY]: number;
		[CacheHitRatioSummary.NETWORK_KEY]: number;
	} = {
		[CacheHitRatioSummary.MEMORY_KEY]: 0,
		[CacheHitRatioSummary.DISK_KEY]: 0,
		[CacheHitRatioSummary.NETWORK_KEY]: 0,
	};

	bundlesCount = 0;

	size: {
		[CacheHitRatioSummary.MEMORY_KEY]: number;
		[CacheHitRatioSummary.DISK_KEY]: number;
		[CacheHitRatioSummary.NETWORK_KEY]: number;
	} = {
		[CacheHitRatioSummary.MEMORY_KEY]: 0,
		[CacheHitRatioSummary.DISK_KEY]: 0,
		[CacheHitRatioSummary.NETWORK_KEY]: 0,
	};

	sizeTotal = 0;

	add(item: PerformanceResourceTiming): void {
		const type = calculateTransferType(item.initiatorType, item.duration, item.transferSize);
		if (type === null) return;

		this.bundles[type] += 1;
		this.bundlesCount += 1;
		this.size[type] += item.encodedBodySize;
		this.sizeTotal += item.encodedBodySize;
	}
}
